import { render, staticRenderFns } from "./SpiritTypeCard.vue?vue&type=template&id=28e95ca4&scoped=true"
import script from "./SpiritTypeCard.vue?vue&type=script&lang=js"
export * from "./SpiritTypeCard.vue?vue&type=script&lang=js"
import style0 from "./SpiritTypeCard.vue?vue&type=style&index=0&id=28e95ca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e95ca4",
  null
  
)

export default component.exports